import React from 'react';
export function HowItWorks() {
  const steps = [{
    title: 'Calibrate',
    desc: 'Use the Parasympathetic Sync to lower your own heart rate so the "Mirror Effect" stops.',
    number: '01'
  }, {
    title: 'Bridge',
    desc: 'Execute the 15-minute tactile sequence to trigger the Melatonin Handshake.',
    number: '02'
  }, {
    title: 'Anchor',
    desc: 'Use the Bottom-First descent and Hand Anchor to ensure they stay asleep when you leave the room.',
    number: '03'
  }];
  return <section className="bg-softWhite py-24 px-6" data-id="element-50">
      <div className="max-w-5xl mx-auto" data-id="element-51">
        <h2 className="text-3xl md:text-4xl font-serif text-center mb-16" data-id="element-52">
          How It Works
        </h2>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-53">
          {steps.map((step, index) => <div key={index} className="relative bg-white p-8 rounded-2xl shadow-sm border border-sage/10" data-id="element-54">
              <span className="absolute -top-6 -left-4 text-6xl font-serif text-sage/20 font-bold" data-id="element-55">
                {step.number}
              </span>
              <h3 className="text-2xl font-serif mb-4 relative z-10" data-id="element-56">
                {step.title}
              </h3>
              <p className="font-sans text-charcoal/80 leading-relaxed relative z-10" data-id="element-57">
                {step.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}